import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { AgentApprovalModeCard } from '@apps/web/components/settings/agent_approval_mode_card';
import { EarlyAccessSection } from '@apps/web/components/settings/early_access_section';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';
import { useOrganization } from '@apps/web/swr_data_fetching/data_fetching_hooks';

export const Route = createFileRoute('/_app/settings/early-access')({
    component: EarlyAccessPage,
});

function EarlyAccessPage() {
    const { organizationId, gates } = useSettingsGates();
    const { data: organization, mutate } = useOrganization(organizationId, {
        reason: 'settings',
    });
    const handleEarlyAccessSaved = useCallback(async () => {
        await mutate();
    }, [mutate]);

    if (!gates.canManageOrgSettings) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }
    return (
        <SettingsPageShell
            title="Early Access"
            description="Try new Phoebe features before they’re generally available."
        >
            <EarlyAccessSection
                organizationId={organizationId}
                features={organization?.features}
                onSaved={handleEarlyAccessSaved}
                variant="embedded"
            />
            {gates.agentV3 && (
                <AgentApprovalModeCard organizationId={organizationId} />
            )}
        </SettingsPageShell>
    );
}
